import React, { useEffect, useReducer, useState } from "react";

import {
  ifscRegex,
  bankAccountRegex,
  pincodeRegex,
  nameRegex,
  accountRegex,
} from ".";

import CustomizedSelect from "../customizedSelect";
import { Input } from "../../../forms/input";
import CustomLoader from "../../../forms/Loader";
import CardComponent from "./lib/CardComponent";
import { MenuItem } from "@material-ui/core";
import { getBankDetails } from "../../../../store/actions/newinvestor";
import {
  getBankList,
  storeInvestmentDetails,
  storeInvestmentParams,
  NewinvestorBankDetails,
  bankAccountTypes,
  storeApplicantParams,
  getAccountTypes,
} from "../../../../store/actions";
import { connect } from "react-redux";
import { validatePennyDrop } from "../../../../store/actions";
import { useLocation } from "react-router-dom";
import { handleError } from "../../../../utils/cart";
import { maskAccountNumber } from ".";

const BankDetails = (props) => {
  const { state } = useLocation();
  // const ValidAccountTypes = {
  //   11: ["Savings"],
  //   12: ["Current"],
  //   21: ["NRE"],
  //   22: ["NRO"],
  // };
  const InputFields = [
    [
      { name: "IFSC", isMandatory: true, type: "text" },
      { name: "Account Type", isMandatory: true },
    ],
    [
      // { name: "MICR Code", isMandatory: false, type: "text" },
      { name: "Bank Name", isMandatory: true, type: "text" },
      { name: "Branch Address", isMandatory: true, type: "text" },
    ],
    [
      { name: "Branch City", isMandatory: true, type: "text" },
      { name: "Branch Pincode", isMandatory: true, type: "number" },
    ],
    [
      { name: "Account Number", isMandatory: true, type: "text",isUserEdited: false },
      { name: "Confirm Account Number", isMandatory: true, type: "text",isUserEdited: false},
    ],
  ];
  const [bankselected, setbankseleected] = useState("");
  const [bankList, setBankList] = useState([]);

  const initialState = {
    IFSC: { value: "" },
    // "MICR Code": { value: "" },
    "Bank Name": { value: "" },
    "Branch Address": { value: "" },
    "Branch City": { value: "" },
    "Branch Pincode": { value: "" },
    "Account Type": { value: "" },
    "Account Number": { value: "" },
    "Confirm Account Number": { value: "" },
    AccountTypes: [],
    isLoading: false,
    BanksListShow: true,
  };
  const [formValues, setFormValues] = useReducer(
    (preValues, newValues) => ({ ...preValues, ...newValues }),
    initialState
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchInvestorBanks();
    const { investmentDetails } = props;
    if (investmentDetails.IFSC) {
      setFormValues({ ...investmentDetails });
      return;
    }
  }, []);

  const fetchBankAccountTypeMasters = async () => {
    try {
      const bankAccountTypes = await props.getAccountTypes({
        opt: "AC",
        SchemeType: props.applicantparams.i_category === "20" ? "Y" : "",
      });

      const isValidResponse = Boolean(
        bankAccountTypes && bankAccountTypes?.Dtinformation?.length
      );

      if (!isValidResponse) return [];

      const accountMasters = bankAccountTypes.Dtinformation.map(
        ({ Account_Type }) => ({
          label: Account_Type,
          value: Account_Type?.toLowerCase(),
        })
      );
      setFormValues({ ...formValues, AccountTypes: accountMasters });
      return accountMasters;
    } catch (error) {
      handleError(error);
      return [];
    }
  };
  const fetchInvestorBanks = async () => {
    const accountTypes = await fetchBankAccountTypeMasters();
    if (props.applicantparams.typeofinvestor === "M") return;
    const response = await props.NewinvestorBankDetails({
      pan: props.applicantparams.i_pangno,
    });

    if (!response.Dtinformation) return;
    if (!response.Dtinformation.length) {
      setFormValues({ BanksListShow: false });
      return;
    }

    const banks = response.Dtinformation;
    const bankDetails = banks[0];

    const accountType = accountTypes.find(
      (x) => x.value === bankDetails?.BnkAcType?.toLowerCase()
    );

    setFormValues({
      bankadd1: bankDetails.BankAdd1,
      bankadd2: bankDetails.BankAdd2,
      bankadd3: bankDetails.BankAdd3,
      IFSC: { value: bankDetails.ifsccode },
      "Bank Name": { value: bankDetails.BankName },
      "Branch Address": {
        value:
          bankDetails.BankAdd1 +
          ", " +
          bankDetails.BankAdd2 +
          " ," +
          bankDetails.BankAdd3,
      },
      "Branch City": { value: bankDetails.BankCity },
      "Branch Pincode": { value: bankDetails.BankPIN },
      "Account Number": { value: bankDetails.BankAcno },
      "Confirm Account Number": { value: bankDetails.BankAcno },
      "Account Type": {
        value: accountType ? bankDetails?.BnkAcType?.toLowerCase() : "",
      },
    });
    const bankList = banks.map((bank) => {
      return { label: bank.BankName, value: bank.BankName };
    });
    setBankList(bankList);
  };

  const handleChange = (label) => (event) => {
    const value = event.target.value;
    switch (label) {
      case "IFSC":
        setFormValues({
          ...formValues,
          [label]: {
            value: value.toUpperCase(),
            isError: !ifscRegex.test(value),
            errorMessage: !value
              ? "IFSC Number is Mandatory"
              : !ifscRegex.test(value)
              ? "Enter a valid IFSC Number"
              : "",
          },
        });
        break;
      case "Account Type": 
        setFormValues({
          ...formValues,
          [label]: {
            value: value,
            isError: value ? false : true,
            errorMessage: value ? "" : "Enter a valid Account Typ",
          },
        });
        break;
      case "Account Number":
        setFormValues({
          ...formValues,
          [label]: {
            value,
            isUserEdited: true,
            isError: !bankAccountRegex.test(value),
            errorMessage: !value
              ? "Account Number is Mandatory"
              : !bankAccountRegex.test(value)
              ? "Enter a valid Account Number"
              : "",
          },
        });
        break;
      case "Confirm Account Number":
        setFormValues({
          ...formValues,
          [label]: {
            value,
            isUserEdited: true,
            isError: !(formValues["Account Number"].value === value),
            errorMessage: !value
              ? "Account Number is Mandatory"
              : !(formValues["Account Number"].value === value)
              ? "Account Numbers does not match"
              : "",
          },
        });
        break;
      default:
        setFormValues({...formValues, [label]: { value } });
        break;
    }
  };
  const getBankDetails = async () => {
    const { IFSC } = formValues;
    if (ifscRegex.test(IFSC.value)) {
      setFormValues({ isLoading: true });
      try {
        const response = await props.getBankDetails({ ifsc: IFSC.value });
        const { DtData } = response;
        const { BankName, BankAdd1, BankAdd2, BankAdd3, BankCity, BankPin } =
          DtData[0];
        setFormValues({
          bankadd1: BankAdd1,
          bankadd2: BankAdd2,
          bankadd3: BankAdd3,
          "Bank Name": { value: BankName },
          "Branch Address": {
            value: BankAdd1 + ", " + BankAdd2 + " ," + BankAdd3,
          },
          "Branch City": { value: BankCity },
          "Branch Pincode": { value: BankPin },
          "Account Number": { value: "" },
          "Confirm Account Number": { value: "" },
        });
      } catch (error) {
        console.log(error);
        setFormValues({
          ...initialState,
          AccountTypes: formValues.AccountTypes,
          IFSC: {
            value: "",
            isError: true,
            errorMessage: "IFSC Not Found, Enter a valid IFSC Number",
          },
        });
      } finally {
        setFormValues({ isLoading: false });
      }
    } else {
      setFormValues({
        IFSC: {
          value: IFSC.value,
          isError: true,
          errorMessage: !IFSC.value
            ? "IFSC Number is Mandatory"
            : "Enter a valid IFSC Number",
        },
      });
    }
  };
  const submit = async () => {
    if (!!formValues.IFSC.value && !formValues["Account Type"].value) {
      setFormValues({
        ...formValues,
        "Account Type": {
          value: "",
          isError: true,
          errorMessage: "Account Type is mandatory",
        },
      });
      return;
    }
    if (
      props.applicantparams["i_category"] === "20" &&
      ["SAVING", "Savings", "Saving", "SAVINGS"].includes(
        formValues["Account Type"].value
      )
    ) {
      setFormValues({
        ...formValues,
        "Account Type": {
          value: "",
          isError: true,
          errorMessage: "Select account type",
        },
      });
      return;
    }

    const keys = ["Bank Name", "Account Type", "Account Number", "IFSC"];

    keys.forEach((key) => {
      if (!formValues[key].value) {
        setFormValues({
          ...formValues,
          [key]: {
            value: "",
            isError: true,
            errorMessage: `${key} is required*`,
          },
        });
        return;
      }
    });

    if (!ifscRegex.test(formValues["IFSC"].value)) {
      setFormValues({
        ...formValues,
        IFSC: {
          value: "",
          isError: true,
          errorMessage: "Enter valid IFS Code",
        },
      });
      return;
    }

    if (!bankAccountRegex.test(formValues["Account Number"].value)) {
      setFormValues({
        ...formValues,
        "Account Number": {
          value: "",
          isError: true,
          errorMessage: "Enter Valid Account Number",
        },
      });
      return;
    }

    if (
      formValues["Account Number"].value !==
      formValues["Confirm Account Number"].value
    ) {
      setFormValues({
        ...formValues,
        "Confirm Account Number": {
          value: "",
          isError: true,
          errorMessage:
            "Account Number and Confirm Account Number should be same",
        },
      });
      return;
    }

    const { AccountTypes, isLoading, bankadd1, bankadd2, bankadd3, ...others } =
      formValues;
    const invdetails = {
      i_ifsccode: formValues.IFSC.value,
      // i_micrcode: formValues["MICR Code"].value,
      i_bnkacname: formValues["Bank Name"].value,
      i_bnkadd1: formValues.bankadd1,
      i_bnkadd3: formValues.bankadd3,
      i_bnkadd2: formValues.bankadd2,
      i_bnkcity: formValues["Branch City"].value,
      i_bnkpin: formValues["Branch Pincode"].value,
      i_bnkacctype: formValues["Account Type"].value.toUpperCase(),
      i_bnkacno: formValues["Account Number"].value,
    };
    if (formValues["Account Type"].value.toUpperCase() === "NRE") {
      props.applicantparams["i_category"] = "21";
      props.storeApplicantParams(props.applicantparams);
    }
    if (formValues["Account Type"].value.toUpperCase() === "NRO") {
      props.applicantparams["i_category"] = "22";
      props.storeApplicantParams(props.applicantparams);
    }
    const cartBankDetails = {
      ifsc: formValues.IFSC.value,
      bank: formValues["Bank Name"].value,
      accType: formValues["Account Type"].value.toLowerCase().includes("saving")
        ? "savings"
        : formValues["Account Type"].value.toLowerCase(),
      existing: "-",
      acceptTerms: "Y",
      accNo: formValues["Account Number"].value,
      address1: formValues.bankadd1,
      address2: formValues.bankadd2,
      address3: formValues.bankadd3,
      city: formValues["Branch City"].value,
      pinCode: formValues["Branch Pincode"].value,
    };
    props.storeInvestmentDetails({ ...formValues });
    props.storeInvestmentParams({
      ...invdetails,
      cart: {
        ...props.cart,
        bankDetails: cartBankDetails,
      },
    });
    props.history.replace("/new-investor-transaction/scheme-details", state);
  };
  const { AccountTypes, isLoading } = formValues;
  return (
    <>
      <span
        className="container-margin"
        style={{ fontSize: "18px", fontWeight: "800", color: "#033f7c" }}
      >
        BANK Details
      </span>
      <CardComponent title="Account Details">
        <CustomLoader display={isLoading} />
        {/* {formValues.BanksListShow && (
          <div className="fatca-input-margin">
            <CustomizedSelect
              fatcawidth={true}
              name="Banks*"
              value={bankselected}
              handleChange={handleBankDetails}
            >
              {bankList.map((item, index) => (
                <MenuItem value={item.value} key={index}>
                  {item.value}
                </MenuItem>
              ))}
            </CustomizedSelect>
          </div>
        )} */}

        {InputFields.map((section) => (
          <div className="flex">
            {section.map((field) => (
              <div
                className="input-margin-investor-flow appbar-div dual-margin"
                onClick={() => console.log(field)}
              >
                {!!field.type ? (
                  <div>
                    <Input
                      name={field.name}
                      image="/images/nav.png"
                      isMandatory={field.isMandatory}
                      type={field.type}
                      value={
                        ["Account Number", "Confirm Account Number"].includes(field.name) &&
                        !formValues[field.name]?.isUserEdited
                          ? maskAccountNumber(formValues[field.name].value)
                          : formValues[field.name].value
                      }
                      onChange={handleChange(field.name)}
                      pattern={field.pattern}
                      onBlur={
                        field.name === "IFSC"
                          ? getBankDetails
                          : handleChange(field.name)
                      }
                      isError={formValues[field.name].isError}
                      isShowError={formValues[field.name].isError}
                      errorMessage={formValues[field.name].errorMessage}
                      id={`${field.name}Field`}
                      width={field.width || ""}
                    />
                    <span style={{ color: "grey", fontWeight: "900" }}>
                      {field.name === "IFSC" &&
                        "*To add new bank, enter IFSC of the new bank account."}
                    </span>
                  </div>
                ) : (
                  <CustomizedSelect
                    name={field.name}
                    isMandatory={field.isMandatory}
                    value={formValues[field.name].value}
                    isError={formValues[field.name].isError}
                    errorMessage={formValues[field.name].errorMessage}
                    handleChange={handleChange(field.name)}
                    placeholder={`Select ${field.name}`}
                    id={`${field.name}Field`}
                    disabled={field.disabled}
                  >
                    {AccountTypes.map((i, index) => (
                      <MenuItem value={i.value} key={index}>
                        {i.label}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                )}
              </div>
            ))}
          </div>
        ))}
        <></>
      </CardComponent>

      <div className="d-flex align-items-center container-margin ">
        <button
             className="new-investor-button new-investor-active rounded ml-auto text-uppercase m-0 mr-0"
             style={{ filter: "grayscale(1) opacity(0.4)" }}
          onClick={() =>
            props.history.replace(
              "/new-investor-transaction/nominee-details",
              state
            )
          }
        >
          BACK
        </button>
        <button
          className="new-investor-button new-investor-active"
          onClick={submit}
        >
          PROCEED
        </button>
      </div>
    </>
  );
};
export default connect(
  ({ newinvestor }) => {
    const { investmentDetails, applicantparams, getbankDetails, cart } =
      newinvestor;
    return {
      investmentDetails,
      applicantparams,
      cart,
      getbankDetails,
    };
  },
  {
    getBankDetails,
    storeInvestmentDetails,
    storeInvestmentParams,
    validatePennyDrop,
    storeApplicantParams,
    getBankList,
    NewinvestorBankDetails,
    bankAccountTypes,
    getAccountTypes,
  }
)(BankDetails);
